import { post, get } from '@tools/request';
// 获取验证码(根据后端要求，register-email 用post, register-short-message 用get)

// 发送邮箱验证码
export function sendEmailVerifyCode(param) {
  return post('/ucenter/register-email', param, true);
}

// 发送短信验证码
export function sendPhoneVerifyCode(param) {
  return get('/ucenter/register-short-message', param, true);
}

// 校验验证码是否OK
export function verifyCode(param) {
  return post('/ucenter/sign-up-validation', param, true);
}

// 邮箱注册
export function signUpEmail(param) {
  return post('/ucenter/sign-up-email', param, true);
}

// 手机注册
export function signUpPhone(param) {
  return post('/ucenter/sign-up-phone', param, true);
}

// 获取区号列表
export function getCountryCodes() {
  return get('ucenter/country-codes');
}

export async function getRefer(referrerCode) {
  return get('ucenter/user/referrer-info', { referrerCode });
}

// 邮箱召回
export const postEmailRecall = (payload) => post(`/market-operation/recalled-email`, payload, true);

// 手机召回
export const postPhoneRecall = (payload) => post(`/market-operation/recalled-phone`, payload, true);

// 获取邮箱后缀
export const getEmailSuffixes = (payload) => get(`/market-operation/mail-suffixes`, payload);
// get(`/market-operation/mail-suffixes?x-version=register-optimization`);

// 获取神策默认策略
export const getSensorsABDefault = (payload) =>
  get(`/market-operation/registerPage/default`, payload);
// get(`/market-operation/registerPage/default?x-version=register-optimization`);
